// router/index.js
import { createRouter, createWebHistory } from "vue-router"; 
import Dictionary from "../project/Dictionary/Main.vue"; 
import Addendum from "../project/Documents/Addendum/Main.vue";
import Policy from "../project/Documents/Policy/Main.vue"; 
import Policies from "../project/Documents/Policies/Main.vue";
import Requests from "../project/Documents/Requests/Main.vue";
import Error from "../project/Error/Error.vue";
import Cancel from "../project/Error/Cancel.vue"; 
import Quotas from "../project/Documents/Quotas/Main.vue";  
import Quota from "../project/Documents/Quota/Main.vue";
import Contract from "../project/Documents/Contract/Main.vue";
import Home from "../project/Home/Main.vue";
import Underwriting from "../project/Documents/Underwriting/Main.vue";
import Contracts from "../project/Documents/Contracts/Main.vue";  
import Person from "../project/CRM/Person/Main.vue";  
import Company from "../project/CRM/Company/Main.vue";  
import Task from "../project/CRM/Task/Main.vue";  
import SignIn from "../project/Auth/SignIn.vue";
import ChangePassword from "../project/Auth/ChangePassword.vue";

const routes = [
  { path: "/", redirect: "/home" },
  { path: "/signIn/:return?/:return2?", name: "SignIn", component: SignIn },
  { path: "/change-password", name: "ChangePassword", component: ChangePassword },
  { path: "/dictionary", component: Dictionary },
  {
    path: "/documents/addendum/:return?/:return2?",
    component: Addendum 
  },
  {
    path: "/documents/policy/:return?",
    component: Policy 
  },
  {
    path: "/documents/policies",
    name: "Policies",
    component: Policies 
  },
  {
    path: "/home",
    name: "Home",
    component: Home 
  },
  { path: "/documents/contracts", component: Contracts },
  { path: "/underwriting/quota/:return?", component: Underwriting }, 
  { path: "/documents/contract/:return?", component: Contract },
  { path: "/documents/quota/:return?", component: Quota },
  { path: "/documents/quotas", component: Quotas },
  { path: "/documents/requests", component: Requests },
  { path: "/crm/person", component: Person },
  { path: "/crm/company", component: Company },
  { path: "/crm/task", component: Task },
  { path: "/error", component: Error },
  { path: "/cancel", component: Cancel },
  { path: "/documents/non", redirect: "/home" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
